// libs
import styled from 'styled-components'
// components
import { Paper as PaperOrigin } from 'components/UI'
// icons
import AssessmentIcon from '@mui/icons-material/Assessment'
// themes
import { colors } from 'themes'
// utils
import { size } from 'polished'

const Header = styled('div')`
  align-items: center;
  background-color: ${colors.darkBlue500};
  border-radius: 4px 4px 0 0;
  color: ${colors.white};
  display: flex;
  font-size: 16px;
  justify-content: space-between;
  padding: 8px;

  && {
    > svg {
      transform: rotate(90deg);
      position: unset;
      z-index: 1;

      ${size('20px')};

      > path {
        fill: ${colors.white};
      }
    }
  }
`

const Preview = styled('div')`
  align-items: center;
  cursor: pointer;
  display: flex;
  height: calc(100% - 40px);
  justify-content: center;

  > img {
    height: 120px;
    width: 250px;
  }
`

const ReportIcon = styled(AssessmentIcon)`
  && {
    ${size('40px')};

    > path {
      fill: ${colors.darkBlue500};
    }
  }
`

const Wrapper = styled(PaperOrigin)`
  margin: 16px 16px 16px 0;
  height: 180px;
  width: 300px;
`

export { Header, Preview, ReportIcon, Wrapper }
